import request from '@/utils/request'

export default async function getEcharts () {
    return await request.post('/api/artArticles/PcSelectzhexian')
}